var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.82 8.59s-.175-1.177-.716-1.694c-.686-.68-1.452-.683-1.804-.723C15.783 6 12.004 6 12.004 6h-.008S8.218 6 5.7 6.173c-.352.04-1.118.044-1.804.723-.54.517-.713 1.693-.713 1.693S3 9.972 3 11.352v1.293c0 1.38.18 2.762.18 2.762s.175 1.177.713 1.693c.686.68 1.586.657 1.986.73C7.321 17.96 12 18 12 18s3.783-.007 6.3-.177c.352-.04 1.118-.043 1.803-.723.542-.516.718-1.693.718-1.693s.179-1.38.179-2.762v-1.293c0-1.38-.18-2.763-.18-2.763m-10.68 5.624V9.42l4.862 2.406z"
})));
export default SvgYoutube;